import { cloneDeep, concat, get, set } from 'lodash';
import React, { FC } from 'react';
import { checkIfHasComment } from 'src/pages/private/online-antrag/application-helper-function/PruefAssistenzHelperFunktion';
import { mapCompponentStrucIndex } from 'src/utils/formStruc';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import MUIAccordionComponent from '../../../../../../../components/ui-component/mui-accordion/MUIAccordionComponent';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import DeleteRecord from '../../../../../../../lib/api/DeleteRecord';
import { APIS } from '../../../../../../../lib/constants/apis';
import {
	ALS_ERLEDIGT_MARKIEREN_LABEL,
	AUSGABE_KATEGORIE,
	FORM_FIELDS_TYPES,
	KOSTEN_ARTEN,
	PRUEF_ASSISTENZ_STATUS,
} from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import { FileValidation, ForceTrue, NonRequired, Required, ValidDate } from '../../../../../../../lib/validation/ValidationTypes';
import { DisplayDate, DisplayEuro } from '../../../../../../../utils/formats';
import { addIndexesToPath, isTrue } from '../../../../../../../utils/helper';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';

// import schemas
import KostenKategorieSchema from 'src/lib/paths/kostenkategorie_FULL_Paths.json';
import KostenPositionSchema from 'src/lib/paths/kostenposition_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
import VerwendungsnachweisSchema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsnachweisSchema.attributes;
const KP_P = KostenPositionSchema.attributes;
const KK_P = KostenKategorieSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const InvestitionsKostenVNLIS: FC<{ kostentraeger: string; standortGroupId: string; unternehmenId: number; kostenKategories: any[] }> = ({
	kostentraeger,
	standortGroupId,
	unternehmenId,
	kostenKategories,
}) => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const isSelectedNachweisReadOnly = (nachweisObj: any) => {
		if (get(nachweisObj, NP_P.Pruefung_Pruefstatus.path) === PRUEF_ASSISTENZ_STATUS.freigegeben) {
			return true;
		} else {
			return readOnly;
		}
	};

	const handleAddNachweisPosition = async (currKostenPosition: any) => {
		let appCopy = cloneDeep(application);
		let newNachweisPostionData = {
			Allgemein_Nr: get(appCopy, VN_P.Verwendungsnachweis_Nachweispositions.path, []).length + 1,
			Verwendungsnachweis: get(appCopy, `id`),
			Allgemein_Kostenposition: get(currKostenPosition, 'id'),
			Allgemein_Kostenart: get(currKostenPosition, KP_P.Allgemein_Kostenposition.path),
			Allgemein_Kostentraeger: get(currKostenPosition, KP_P.Allgemein_Kostentraeger.path),
			Allgemein_Unternehmen_Institution: get(currKostenPosition, `${KP_P.Unternehmen.path}.id`),
			Allgemein_Standort_Group_ID: get(currKostenPosition, KP_P.Allgemein_Standort_Group_ID.path),
			Allgemein_Bezeichnung: get(currKostenPosition, KP_P.Allgemein_Bezeichnung.path),
			Kostennachweise_Nachweise: [{ Kommentar: '' }],
		};
		set(
			appCopy,
			`${VN_P.Verwendungsnachweis_Nachweispositions.path}.${get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []).length}.attributes`,
			newNachweisPostionData,
		);

		saveApplication(false, appCopy);
	};
	const handleDeleteNachweis = async (id: number) => {
		try {
			let appCopy = cloneDeep(application);
			const allNachweisPosition = get(appCopy, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

			set(
				appCopy,
				VN_P.Verwendungsnachweis_Nachweispositions.path,
				allNachweisPosition.filter((ele: any) => ele.id !== id),
			);
			const res = await DeleteRecord(APIS.Nachweisposition, id);
			if (res) saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Deleting Nachweisposition ', err);
		}
	};

	return (
		<>
			{get(application, VN_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []).map(
				// eslint-disable-next-line array-callback-return
				(eachKostenPosition: any, i: number) => {
					if (
						get(eachKostenPosition, KP_P.Allgemein_Kostentraeger.path) === kostentraeger &&
						get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Investitionskosten &&
						get(eachKostenPosition, `${KP_P.Unternehmen.path}.id`) === unternehmenId &&
						get(eachKostenPosition, KP_P.Allgemein_Standort_Group_ID.path) === standortGroupId
					) {
						return (
							<MUIAccordionComponent
								key={i}
								summaryTitle={`${get(eachKostenPosition, KP_P.Allgemein_Bezeichnung.path, '')}, Gesamtsumme: ${DisplayEuro(
									get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, [])
										.filter((el: any) => get(el, `${NP_P.Allgemein_Kostenposition.path}.id`) === get(eachKostenPosition, 'id'))
										.reduce((acc: number, curr: any) => acc + parseFloat(get(curr, NP_P.Allgemein_Ausgaben_Kosten.path, 0)), 0),
								)}`}
								summaryTitleFontWeight={500}
								showDeleteButton={false}
								showAddButton={true}
								addButtonTooltip='neue Position hinzufügen'
								onAdd={() => handleAddNachweisPosition(eachKostenPosition)}
							>
								{/* eslint-disable-next-line array-callback-return */}
								{get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []).reduce(
									(acc: JSX.Element[], eachNachweis: any, nachweisIndex: number) => {
										if (get(eachNachweis, `${NP_P.Allgemein_Kostenposition.path}.id`) === get(eachKostenPosition, 'id')) {
											const accordionId = `accordion-${i}-${nachweisIndex}`;
											acc.push(
												<MUIAccordionComponent
													key={accordionId}
													summaryTitle={`Rechnung ${acc.length + 1}, Datum: ${DisplayDate(get(eachNachweis, NP_P.Allgemein_Datum_Der_Rechnung.path, ''), '--.--.----')}, Summe: ${DisplayEuro(get(eachNachweis, NP_P.Allgemein_Ausgaben_Kosten.path, 0))}`}
													summaryBackgroundColor='#f1f1f3'
													onDelete={() => handleDeleteNachweis(get(eachNachweis, 'id'))}
													deleteButtonTooltip='Position löschen'
													hasComment={isTrue(
														checkIfHasComment(
															readOnly,
															application,
															addIndexesToPath(
																VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Hinweis_Fuer_Den_Antragsteller
																	.path,
																[`${nachweisIndex}`],
																['Verwendungsnachweis_Nachweispositions'],
															),
														),
													)}
													/* forceCollapsed={collapseAll} */
												>
													<PruefAssistenz
														statusPath={addIndexesToPath(
															VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Pruefstatus.path,
															[`${nachweisIndex}`],
															['Verwendungsnachweis_Nachweispositions'],
														)}
														hinweisPath={addIndexesToPath(
															VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Hinweis_Fuer_Den_Antragsteller
																.path,
															[`${nachweisIndex}`],
															['Verwendungsnachweis_Nachweispositions'],
														)}
														ueberarbeitetAmPath={addIndexesToPath(
															VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Ueberarbeitet_Am.path,
															[`${nachweisIndex}`],
															['Verwendungsnachweis_Nachweispositions'],
														)}
														erledigtPath={addIndexesToPath(
															VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Erledigt.path,
															[`${nachweisIndex}`],
															['Verwendungsnachweis_Nachweispositions'],
														)}
														formStruc={mapFormStruc(PruefAssistenzStruc(), nachweisIndex)}
													/>
													<CreateForm
														formStruc={mapFormStruc(formStrucNachweis(application, nachweisIndex, kostenKategories), nachweisIndex)}
														formValues={application}
														updateFormValuesFunc={setApplicationProperty}
														readOnly={isSelectedNachweisReadOnly(eachNachweis)}
														api={APIS.Nachweisposition}
													/>
													<CreateForm
														formStruc={mapFormStruc(formStrucNachweisSpalteDatums(), nachweisIndex)}
														formValues={application}
														updateFormValuesFunc={setApplicationProperty}
														readOnly={isSelectedNachweisReadOnly(eachNachweis)}
														api={APIS.Nachweisposition}
													/>
													<CreateForm
														formStruc={mapFormStruc(formStrucNachweisGrund(), nachweisIndex)}
														formValues={application}
														updateFormValuesFunc={setApplicationProperty}
														readOnly={isSelectedNachweisReadOnly(eachNachweis)}
														api={APIS.Nachweisposition}
													/>

													<CreateForm
														formStruc={mapFormStruc(formStrucNachweisDatei(), nachweisIndex)}
														formValues={application}
														updateFormValuesFunc={setApplicationProperty}
														readOnly={isSelectedNachweisReadOnly(eachNachweis)}
														api={APIS.Nachweisposition}
													/>
												</MUIAccordionComponent>,
											);
										}
										return acc;
									},
									[],
								)}
							</MUIAccordionComponent>
						);
					}
				},
			)}
		</>
	);
};
export default InvestitionsKostenVNLIS;

const PruefAssistenzStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucNachweis = (application: any, nachweisIndex: number, kostenKategories: any[]) => {
	const selectedKostenKategorie = getSelectedKostenKategorie(nachweisIndex, application, kostenKategories);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Bezeichnung,
					label: 'Kostenkategorie',
					disabled: true,
				},
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];

	if (selectedKostenKategorie === AUSGABE_KATEGORIE.LadeTankInfrastruktur) {
		struc.push({
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Kostenposition.schema.attributes
						.Kalkulation_Ladeinfrastruktur_Lis.schema.attributes.Kalkulation_Ladeinfrastruktur_Art_Der_Ladeinfrastruktur,
					label: 'Art der Ladeinfrastruktur',
					disabled: true,
				},
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Kostenposition.schema.attributes
						.Kalkulation_Ladeinfrastruktur_Lis.schema.attributes.Kalkulation_Ladeinfrastr_0267182084_ler_Bezeichnung_Ggf_Standort,
					label: 'Hersteller / Bezeichnung',
					disabled: true,
				},
			],
			userProps: { columnToDivide: 2 },
		});
	}

	return struc;
};
const formStrucNachweisSpalteDatums = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Datum_Des_Auftrags,
					validation: [{ validateFunction: ValidDate }],
				},
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Datum_Der_Leistungserbringung,
					validation: [{ validateFunction: ValidDate }],
				},
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Datum_Der_Rechnung,
					validation: [{ validateFunction: ValidDate }],
				},
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Datum_Der_Zahlung,
					validation: [{ validateFunction: ValidDate }],
				},
			],
		},
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten,
					format: 'currency',
				},
			],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
	];
	return struc;
};

const formStrucNachweisGrund = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Grund_Der_Zahlung_Erlaeuterung,
					validation: [{ validateFunction: Required }],
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const formStrucNachweisDatei = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Kostennachweise_Nachweise,
					type: FORM_FIELDS_TYPES.editableTable,
					tableLabel: 'Kostennachweise',
					fieldProps: { Datei: { width: '20rem' }, Kommentar: { label: 'Kommentar (optional)' } },
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStrucNachweisDatei = () => {
	const struc = [
		{
			fields: [
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Kostennachweise_Nachweise.schema.attributes.Datei,
					validation: [{ validateFunction: Required }, { validateFunction: FileValidation }],
				},
				{
					...VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Kostennachweise_Nachweise.schema.attributes.Kommentar,
					validation: [{ validateFunction: NonRequired }],
				},
			],
		},
	];
	return struc;
};
const mapFormStruc = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, VN_P.Verwendungsnachweis_Nachweispositions.path.length) +
						`.${index}` +
						pathWithoutIndex.slice(VN_P.Verwendungsnachweis_Nachweispositions.path.length),
				};
			}),
		};
	});
	return result;
};
export const getFormStrucInvestitionsKostenVNLIS = (
	application: any,
	kostentraeger: string,
	standortGroupID: string,
	unternehmenId: number,
	kostenKategopries: any[],
	_readOnly: boolean,
) => {
	let result: FormStrucItem[] = [];
	get(application, VN_P.Foerderantrag.schema.attributes.Foerderantrag_Kostenpositions.path, []).forEach((eachKostenPosition: any) => {
		if (
			get(eachKostenPosition, KP_P.Allgemein_Kostentraeger.path) === kostentraeger &&
			get(eachKostenPosition, KP_P.Allgemein_Kostenart_Finanzierung.path) === KOSTEN_ARTEN.Investitionskosten &&
			get(eachKostenPosition, `${KP_P.Unternehmen.path}.id`) === unternehmenId &&
			get(eachKostenPosition, KP_P.Allgemein_Standort_Group_ID.path) === standortGroupID
		) {
			const allNachweisPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

			allNachweisPositions.forEach((eachNachweis: any, nachweisIndex: number) => {
				if (get(eachNachweis, `${NP_P.Allgemein_Kostenposition.path}.id`) === get(eachKostenPosition, 'id')) {
					const isHinweisFieldRequired =
						get(eachNachweis, NP_P.Pruefung_Hinweis_Fuer_Den_Antragsteller.path) && !isTrue(get(eachNachweis, NP_P.Pruefung_Erledigt.path));

					const PruefAssistenzStrucWithIndex = mapFormStruc(PruefAssistenzStruc(), nachweisIndex);
					const formStrucNachweisWithIndex = mapFormStruc(formStrucNachweis(application, nachweisIndex, kostenKategopries), nachweisIndex);
					const formStrucNachweisSpalteDatumsWithIndex = mapFormStruc(formStrucNachweisSpalteDatums(), nachweisIndex);

					const formStrucNachweisGrundWithIndex = mapFormStruc(formStrucNachweisGrund(), nachweisIndex);

					const nachweisPositionPath = VN_P.Verwendungsnachweis_Nachweispositions.path;

					const formStrucNachweisDateiWithIndex = mapCompponentStrucIndex(
						application,
						customFormStrucNachweisDatei(),
						`${nachweisPositionPath}.${nachweisIndex}.attributes.Kostennachweise_Nachweise`,
					);

					if (isHinweisFieldRequired)
						result = concat(
							result,
							PruefAssistenzStrucWithIndex,
							formStrucNachweisWithIndex,
							formStrucNachweisSpalteDatumsWithIndex,
							formStrucNachweisGrundWithIndex,
							formStrucNachweisDateiWithIndex,
						);
					else
						result = concat(
							result,
							formStrucNachweisWithIndex,
							formStrucNachweisSpalteDatumsWithIndex,
							formStrucNachweisGrundWithIndex,
							formStrucNachweisDateiWithIndex,
						);
				}
			});
		}
	});
	return result;
};

/**
 * ****************************************************************************************
 * ***************************** HELPER FUNCTIONS *****************************************
 * ****************************************************************************************
 */
function getSelectedKostenKategorie(index: number, application: any, kostenKategories: any[]) {
	let selectecKatogorie = get(
		application,
		addIndexesToPath(
			VN_P.Verwendungsnachweis_Nachweispositions.schema.attributes.Allgemein_Kostenposition.schema.attributes.Allgemein_Kostenkategorie.path,
			[`${index}`],
			['Verwendungsnachweis_Nachweispositions'],
		),
	);

	if (typeof selectecKatogorie === 'object') {
		return get(selectecKatogorie, KK_P.Allgemein_Ausgabekategorie.path, '');
	} else {
		let kategorieObj = kostenKategories.find((ele) => parseInt(get(ele, 'id')) === parseInt(selectecKatogorie));
		return get(kategorieObj, KK_P.Allgemein_Ausgabekategorie.path, '');
	}
}
